import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IProductSpecificationData, IProductSpecificationViewProps } from '@msdyn365-commerce-modules/product-specification';
import { IProductSpecificationProps as IExtensionProps } from '../definition-extensions/product-specification.ext.props.autogenerated';

const ProductSpecificationView: React.FC<IProductSpecificationViewProps & IExtensionProps<IProductSpecificationData>> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult } = props;

    const rowdata =
        productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult.filter(row => {
            const rowEl = row && (row as JSX.Element);
            const attribute = props.data.productSpecificationData.result?.find(a => a.RecordId === Number(rowEl?.key ?? 0));
            return attribute && !props.config.excludedAttributes?.map(a => a.toUpperCase()).includes(attribute.Name?.toUpperCase() ?? '');
        });

    return rowdata && ArrayExtensions.hasElements(rowdata) ? (
        <Module {...ProductSpecification}>
            {props.title}
            <Node {...ProductSpecificationTableProps}>
                <Node {...ProductSpecificationTableBodyProps}>{rowdata}</Node>
            </Node>
        </Module>
    ) : null;
};

export default ProductSpecificationView;
